import { render, staticRenderFns } from "./IndicadoresDocumentos.vue?vue&type=template&id=6357a51b&scoped=true&lang=pug&"
import script from "./IndicadoresDocumentos.vue?vue&type=script&lang=js&"
export * from "./IndicadoresDocumentos.vue?vue&type=script&lang=js&"
import style0 from "./IndicadoresDocumentos.vue?vue&type=style&index=0&id=6357a51b&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6357a51b",
  null
  
)

export default component.exports